import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./pages/RootLayout";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import Signup from "./pages/Signup/Signup";
import AptitudeTest from "./pages/AtitudeTest/AptitudeTest";
import AptitudeTestQuestions from "./pages/AptitudeTestQuestions";
import OtpVerification from "./pages/Signup/OtpVerification";
import Dashboard from "./pages/Dashboard";
import "@ant-design/v5-patch-for-react-19";
import { ConfigProvider, theme } from "antd";
import CourseView from "./pages/Dashboard/Courses/CourseView";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import Assignments from "./pages/Dashboard/Assignments";
import Notes from "./pages/Dashboard/Notes";
import Sessions from "./pages/Dashboard/Sessions";
import Courses from "./pages/Dashboard/Courses";
import Achievements from "./pages/Dashboard/Achievments";
import LoadingScreen from "./pages/LoadingScreen";
import PrivateRoute, { verifyUser } from "./PrivateRoute";
import useAxiosInterceptor from "./utils/axiosInterceptors";
import ScrollToTop from "./ScrollToTop.jsx";
import FrameViewer from "./components/FrameViewer.jsx";
import PrivacyPolicy from "./pages/Home/PrivacyPolicy";
import TermsAndConditions from "./pages/Home/TermsAndConditions";
import TermsOfUse from "./pages/Home/TermsOfUse";
import AboutUs from "./pages/Home/AboutUs";
import SuperAdminPage from "./pages/SuperAdminPage.jsx";
import Certificate from "./pages/Certificate/index.jsx";
import PublicCertificate from "./pages/Certificate/PublicCertificate.jsx";
import NotFound from "./NotFound.jsx";
import PurchaseCourseView from "./pages/Dashboard/Courses/PurchaseCourseView.jsx";
import { useEffect, useState } from "react";
import { Bounce, ToastContainer } from "react-toastify";
function App() {
  // const [darkMode, setDarkMode] = useState(
  //   localStorage.getItem("theme") === "dark"
  // );

  // useEffect(() => {
  //   if (darkMode) {
  //     document.documentElement.classList.add("dark");
  //     localStorage.setItem("theme", "dark");
  //   } else {
  //     document.documentElement.classList.remove("dark");
  //     localStorage.setItem("theme", "light");
  //   }
  // }, [darkMode]);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Poppins",
        },
        // algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <RouterProvider router={router} />
      <LoadingScreen />
    </ConfigProvider>
  );
}

export default App;

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  {
    path: "/brochure",
    element: (
      <FrameViewer url="https://pronttera-resource.s3.ap-south-1.amazonaws.com/broucher/Circuit+Brochure.pdf" />
    ),
  },
  {
    path: "/frontend-curriculum",
    element: (
      <FrameViewer url="https://pronttera-resource.s3.ap-south-1.amazonaws.com/frontend-curriculum/Detailed+curriculum.pdf" />
    ),
  },
  { path: "/certificate/:id", element: <PublicCertificate /> },
  // { path: "/super-admin", element: <SuperAdminPage /> },
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "courses/:id", element: <CourseView isHomePage /> },
      { path: "otp-verification", element: <OtpVerification /> },
      {
        path: "aptitude-test",
        children: [
          { index: true, element: <AptitudeTest /> },
          { path: "questions", element: <AptitudeTestQuestions /> },
        ],
      },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms-and-conditions", element: <TermsAndConditions /> },
      { path: "terms-of-use", element: <TermsOfUse /> },
      { path: "about-us", element: <AboutUs /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "/dashboard",
    element: <PrivateRoute />, // Replace true with actual auth check
    children: [
      { index: true, element: <DashboardHome /> },
      { path: "assignment", element: <Assignments /> },
      { path: "notes", element: <Notes /> },
      { path: "sessions", element: <Sessions /> },
      { path: "courses", element: <Courses /> },
      { path: "enrollments/:id", element: <CourseView /> },
      { path: "courses/:id", element: <PurchaseCourseView /> },
      { path: "achievements", element: <Achievements /> },
      { path: "certificate/:id", element: <Certificate /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
